import React from "react";

const Homecomponent = () => {
  return (
    <>
      <div className="homebox">
        <div className="homebox1">
            <div className="homebox1img1">
                <p className="homebox1img1-p1">Title of vertical gallery</p>
                <p className="homebox1img1-p2">Traval/August 21 2022</p>
            </div>
         
        </div>
        <div className="homebox2">
            <div className="homebox2img1">
                <p className="homebox2-p1">The sound cloud</p>
                <p className="homebox2-p2">You loved is doomed</p>
                <p className="homebox2-p3">Traval / August 21 2022</p>

            </div>
            <div className="homebox2img2">
                <p className="homebox2-p4">The sound cloud</p>
                <p className="homebox2-p5">You loved is doomed</p>
                <p className="homebox2-p6">Traval/August 21 2022</p>

            </div>
          
        </div>
      </div>
    </>
  );
};

export default Homecomponent;
